export default __webpack_public_path__ + "static/char-42-anr-cda1f295b6946eb985c1ad2f2a386e36.gif";